export enum LocalStorageKeys {
    COUNTRY = "country",
    LANGUAGE = "language",
}
